import { render, staticRenderFns } from "./AppDesktop.vue?vue&type=template&id=04f1fd4a&"
import script from "./AppDesktop.vue?vue&type=script&lang=ts&"
export * from "./AppDesktop.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('04f1fd4a', component.options)
    } else {
      api.reload('04f1fd4a', component.options)
    }
    module.hot.accept("./AppDesktop.vue?vue&type=template&id=04f1fd4a&", function () {
      api.rerender('04f1fd4a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/views/AppDesktop.vue"
export default component.exports